import React, { useState, useEffect, createContext } from "react";
import { useHistory } from "react-router-dom";

const TicketsContext = createContext();

const TicketsContextProvider = ({ children }) => {
	const [currentTicket, setCurrentTicket] = useState({ id: null, code: null });
	// Contador de refresh das listas de tickets. Ações locais (ex.: ACEITAR na
	// janela de origem) incrementam este valor para forçar o refetch das listas,
	// garantindo atualização imediata mesmo quando o socket desta sessão não
	// recebe o evento (ex.: sessão única derrubada por login em outra janela).
	const [ticketsListRefresh, setTicketsListRefresh] = useState(0);
	const refreshTicketsList = () => setTicketsListRefresh((v) => v + 1);
    const history = useHistory();

    useEffect(() => {
        if (currentTicket.id !== null && currentTicket.uuid !== undefined) {
            history.push(`/tickets/${currentTicket.uuid}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentTicket])

	return (
		<TicketsContext.Provider
			value={{ currentTicket, setCurrentTicket, ticketsListRefresh, refreshTicketsList }}
		>
			{children}
		</TicketsContext.Provider>
	);
};

export { TicketsContext, TicketsContextProvider };
